// Module
var code = `<div class="btn-spinner" ng-if="\$ctrl.isLoading"></div>
<div id="{{\$ctrl.formname}}" ng-bind-html="\$ctrl.trustedHtmlForm" ng-if="\$ctrl.trustedHtmlForm"></div>
<div class="text-danger" ng-if="\$ctrl.hasError">Failed to load form data from the server.</div>`;
// Exports
module.exports = code;